import api from '../api'

export default {
    namespaced: true,
    state: {
        sng:{
            sngList: [],
            sngListTotal: 0,
        },
        sngDetail:{
            "blindType": 0,
            "creatorID": 0,
            "creatorName": "",
            "entryTime": "",
            "gameIcon": "",
            "gameType": 0,
            // "initialChip": 0,
            "initialScore": 0,
            "isAllowAppend": 0,
            "isAllowDelay": 0,
            "isAllowRebuy": 0,
            "isGpsLimit": 0,
            "totalRegistationFee":0,
            "isIpLimit": 0,
            "isVirtual": 0,
            "limitPlayers": 0,
            "matchName": "",
            "prizeIcon": "",
            "prizeName": "",
            "registationFee": 0,
            "roomNumType": 9,
            "sbChip": 0,
            "serviceFee": 0,
            "showTime": "",
            "startTime": "",
            "updateBlindTime": 0,
            "voucherId": 0,
            "blindTypeLabel":'快速盲注表',
            'participateNum':0,
            "totalBonus":0
        },
        player:{
            list:[],
            totalPage: 0
        }
    },
    mutations: {
        setDataSngList(state, info) {
            state.sng.sngList = info.beanList;
            state.sng.sngListTotal = info.total
        },
        setDataSngDetail(state, info) {
            state.sngDetail = info;
        },
        setDataSngPlayer(state, info) {
            state.player.list = info.beanList;
            state.player.totalPage = info.total;
        }
    },
    actions: {
        createSngApi({commit}, params) {
            return api.post('/sng/create', '创建 sng', params).then(res => {
                // commit('setDataSngBannerList', res.data)
            })
        },
        sngMangZhuList(){
            return api.post('/mangZhuGrade/listAll');
        },
       sngViewAtCount({commit},aiType){
            return api.post(`/sng/view/aiCount/${aiType}`, '机器人数量');
        },
        sngListApi({commit}, params) {
            return api.post('/sng/list', '赛事列表', params).then(res=>{
                // dispatch('getBannerList',{type:params.type})
                commit('setDataSngList', res.data)
            })
        },
        sngDetailApi({commit}, params) {
            return api.post('/sng/detail', '比赛详情', params).then(res=>{
                commit('setDataSngDetail', res.data)
            })
        },
        disSngApi({dispatch}, params) {
            return api.post('/sng/cancel', '取消/解散Sng', params).then(()=>{
                // dispatch('getBannerList',{page,type})
            })
        },
        sngPlayerLApi({commit}, params) {
            return api.post('/sng/players/detail', '获取玩家列表', params).then(res=>{
                commit('setDataSngPlayer', res.data)
            })
        }
    }
}